/**
 * Admin Auth usa EQAUTH_ENV (environment.eqauth.url).
 * Bearer e headers de contexto são aplicados pelos interceptors do módulo auth
 * (incluindo URLs de `eqauth.url`).
 */
export const authAdminProviders = [] as const;

export const authAdminInterceptors = [] as const;
